var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"commonHeader"},[_c('el-button',{staticClass:"btn",attrs:{"type":"primary","icon":"el-icon-menu","size":"mini"},on:{"click":_vm.isCollage}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }